import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchUsers(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/users/get-users', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchUser(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/users/get-user-details?id=${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addUser(ctx, userData) {
      console.log('userData', userData)
      return new Promise((resolve, reject) => {
        axios
          .post('/users/add-user', { data: userData })
          .then(response => {
            resolve(response)
          })

          .catch(error => reject(error.response))
      })
    },
    editUser(ctx, userData) {
      console.log('Edit', userData)
      return new Promise((resolve, reject) => {
        axios
          .post('/users/edit-user', { data: userData })
          .then(response => {
            resolve(response)
          })

          .catch(error => reject(error.response))
      })
    },
  },
}
